
var ptTimeSelectRegional = {
	"es": Object.assign({}, jQuery.ptTimeSelect.options, {
		hoursLabel: 'Hora',
		minutesLabel: 'Minutos',
		setButtonLabel: 'Aplicar',
	}),
	"fr": Object.assign({}, jQuery.ptTimeSelect.options, {
		hoursLabel: 'Heure',
		minutesLabel: 'Minutes',
		setButtonLabel: 'Réglage',
	}),
	"en": Object.assign({}, jQuery.ptTimeSelect.options)
};